import { Modifier } from '@dnd-kit/core';
import { CalendarSettingsType } from '@modules/planner/calendar/calendar-types';

export const snapToRow: Modifier = (args) => {
  const { transform } = args;

  if (args.over && args.activeNodeRect) {
    const settings: CalendarSettingsType = args.over.data.current!.settings;
    const wrapRef = args?.over?.data?.current?.chartWrapperRef;
    const viewportRect = wrapRef.current?.getBoundingClientRect();

    const isDay = settings.dimension === 'day';
    const isWeek = settings.dimension === 'week';

    const stepSize = settings.stepWidth;

    const gridSize =
      isDay || isWeek
        ? stepSize / 4
        : stepSize / (settings.endingHour - settings.startingHour);

    // detect left edge of hovered hour block
    const hourBeginPosition = args.over.rect.left - args.activeNodeRect!.left;

    // find the closest 15 minute interval
    const offset = Math.ceil((transform.x - hourBeginPosition) / gridSize) - 1;

    const y =
      Math.max(args.over.rect.top, viewportRect.top + settings.headerHeight) -
      args.activeNodeRect!.top;

    return {
      ...transform,
      y: y,
      x: hourBeginPosition + offset * gridSize,
    };
  } else {
    return transform;
  }
};
